import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { onSubmitEventsRegistrationContactForm } from "../../redux/auth/actions";
import moment, { calendarFormat } from "moment";
import Loader from "../Loader/Loader";
import { getCalendarSessionList } from "../../redux/events/actions";
import { UI } from "@pdftron/webviewer";
import Page from "../Page";
import "./EventsRegistrationPage.scss";
// import FooterNewGuest from "../FooterNewGuest";

const EventsRegistrationPage = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const brokerage_id = params.get("id");
  const uid = params.get("uid");
  const isGuest = params.get("guest");
  // const session_id = params.get("sessionId");
  console.log("brokerage_id", brokerage_id);
  // const [interestedEvents, setInterestedEvents] = useState([]);

  // const [selectedSessionId, setSelectedSessionId] = useState("");
  // useEffect(() => {
  //   setSelectedSessionId(localStorage.getItem("SELECTED_SESSION_ID"));
  // }, [localStorage.getItem("SELECTED_SESSION_ID")]);

  // useEffect(() => {
  //   changeSelectedEvent(localStorage.getItem("SELECTED_SESSION_ID"));
  // }, [interestedEvents]);

  const [selectedSessionOfEvent, setSelectedSessionOfEvent] = useState();

  useEffect(() => {
    setSelectedSessionOfEvent(
      `${localStorage.getItem("SELECTED_SESSION_NAME")} (${localStorage.getItem(
        "SELECTED_EVENT_NAME"
      )})`
    );
  }, [localStorage.getItem("SELECTED_SESSION_NAME")]);

  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [number, setNumber] = useState();
  const [formError, setFormError] = useState("");
  const [formSuccess, setFormSuccess] = useState("");
  const [isLoadingLogin, setIsLoadingLogin] = useState(false);
  const [apiCalled, setApiCalled] = useState(false);
  const [selectedSessionName, setSelectedSessionName] = useState("");
  const [selectedEventName, setSelectedEventName] = useState("");
  const [brokerageFrom, setBrokerageFrom] = useState("");
  // const [interestedBrokerageEvents, setInterestedBrokerageEvents] = useState(
  //   []
  // );
  // const [interestedXselEvents, setInterestedXselEvents] = useState([]);

  const eventsRegistrationResponse = useSelector(
    (state) => state.auth.eventsRegistrationRes
  );

  // const calenderSessionListArray = useSelector(
  //   (state) => state.events.calendarSessionList
  // );

  // useEffect(() => {}, [selectedEventName]);

  // useEffect(() => {
  //   if (!_.isEmpty(calenderSessionListArray)) {
  //     let interestedXselEventList = [];
  //     let interestedBrokerageEventsList = [];
  //     let interestedEventsList = [];
  //     // for (let calendarData of calenderSessionListArray) {
  //     if (calenderSessionListArray.status === "success") {
  //       const sessionData = _.clone(calenderSessionListArray.payload.payload);
  //       if (_.isArray(sessionData) && !_.isEmpty(sessionData)) {
  //         console.log("sessionData Calendar List Array", sessionData);

  //         for (let session of sessionData) {
  //           let interestedEvent = {
  //             sessionName: session?.session_name,
  //             sessionId: session?.session_id,
  //             eventName: session?.event_name,
  //             eventId: session?.event_id,
  //           };
  //           if (session?.source === "xsel") {
  //             interestedXselEventList.push(interestedEvent);
  //             interestedEventsList.push(interestedEvent);
  //           } else if (session?.source === "broker") {
  //             interestedBrokerageEventsList.push(interestedEvent);
  //             interestedEventsList.push(interestedEvent);
  //           }
  //         }

  //         setInterestedBrokerageEvents(interestedBrokerageEventsList);
  //         setInterestedXselEvents(interestedXselEventList);
  //         setInterestedEvents(interestedEventsList);
  //         setIsLoadingLogin(false);
  //       }
  //     } else {
  //       setInterestedEvents([]);
  //       setIsLoadingLogin(false);
  //     }
  //     // }
  //   }
  // }, [calenderSessionListArray]);

  console.log("res", eventsRegistrationResponse);

  useEffect(() => {
    if (eventsRegistrationResponse?.status === "success" && apiCalled) {
      console.log("resp", eventsRegistrationResponse);
      setFormSuccess(eventsRegistrationResponse?.payload?.message);
      window.scrollTo(0,0);
      setIsLoadingLogin(false);
      setApiCalled(false);
      setTimeout(() => {
        setFormSuccess();
        setName("");
        setEmail("");
        setNumber("");
      }, 5000);
    } else if (apiCalled) {
      setFormError(eventsRegistrationResponse?.error?.message);
      window.scrollTo(0,0);
      setIsLoadingLogin(false);
      setApiCalled(false);
      setTimeout(() => {
        setFormError();
        setName("");
        setEmail("");
        setNumber("");
      }, 5000);
    }
  }, [eventsRegistrationResponse]);

  const handleSubmit = (event) => {
    console.log(
      "submitted o-p",
      brokerage_id,
      selectedSessionName,
      selectedEventName
    );
    event.preventDefault();
    setIsLoadingLogin(true);
    setApiCalled(true);
    let selectedSession = localStorage.getItem("SELECTED_SESSION_NAME");
    let selectedEvent = localStorage.getItem("SELECTED_EVENT_NAME");
    if (!_.isEmpty(brokerage_id) && selectedSession && selectedEvent) {
      dispatch(
        onSubmitEventsRegistrationContactForm({
          module: "eventsRegistrationContactForm",
          postData: {
            name: name,
            email: email,
            phone_number: number,
            brokerage_id: atob(brokerage_id),
            event_name: selectedEvent,
            session_name: selectedSession,
            brokerage_from: brokerageFrom,
            user_id: atob(uid),
          },
        })
      );
    } else {
      setFormError("please select event you are interested in!");
      setIsLoadingLogin(false);
      setApiCalled(false);
    }
  };

  // const [currentWeekStart, setCurrentWeekStart] = useState(
  //   moment().startOf("week")
  // );

  // function getNextSixMonthsDate() {
  //   let currentDate = new Date();
  //   currentDate.setMonth(currentDate.getMonth() + 6);
  //   let month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
  //   let day = currentDate.getDate().toString().padStart(2, "0");
  //   let year = currentDate.getFullYear();

  //   return `${month}/${day}/${year}`;
  // }

  // function formatDate() {
  //   let currentDate = new Date();
  //   let month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
  //   let day = currentDate.getDate().toString().padStart(2, "0");
  //   let year = currentDate.getFullYear();

  //   return `${month}/${day}/${year}`;
  // }

  // useEffect(() => {
  //   let date_range = {
  //     start_date: formatDate(),
  //     end_date: getNextSixMonthsDate(),
  //   };

  //   setIsLoadingLogin(true);

  //   dispatch(
  //     getCalendarSessionList({
  //       module: "calendarSessionListEcom",
  //       postData: {
  //         token: "",
  //         date_range,
  //         user_id: atob(uid),
  //       },
  //     })
  //   );
  // }, [uid]);

  // const changeSelectedEvent = (session_id) => {
  //   console.log("check--", session_id, interestedEvents);
  //   setFormError("");
  //   const selectedEventForSubmission = interestedEvents?.filter(
  //     (item) => item?.sessionId === session_id
  //   );
  //   setSelectedSessionId(session_id);
  //   setSelectedEventName(selectedEventForSubmission[0]?.eventName);
  //   setSelectedSessionName(selectedEventForSubmission[0]?.sessionName);

  //   console.log("svv-", selectedEventForSubmission);
  // };

  const [valid, setValid] = useState(true);
  const [isEmailFocused, setisEmailFocused] = useState(false);
  const validateEmail = (email) => {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\\.,;:\s@"]+\.)+[^<>()[\]\\.,;:\s@"]{3,})$/i;
    return re.test(String(email).toLowerCase());
  };

  const handleEmailChange = (e) => {
    const emailInput = e.target.value;
    setEmail(emailInput);
  };

  const handleEmailBlur = () => {
    setValid(validateEmail(email));
    setisEmailFocused(false);
  };

  const handleEmailFocus = () => {
    setisEmailFocused(true);
  };

  return (
    <>
     {isGuest ==="true" ? 
    <>
      <Loader start={isLoadingLogin} />
      <div className="contact-us-page">
      <section className="login-sec ">
        <div className="login-container ">
          <div className="container">
            <div className="row bglogin">
              {/* <div className="col-md-12 back-btn-container">
                <button type="button" className="view-all-btn">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    style={{transform: "scale(-1,1)"}}
                  >
                    <path
                      d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                      stroke="#6941C6"
                      strokeWidth="1.66667"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>{" "}
                  Back
                </button>
              </div> */}
              <div className="col-xl-12 col-lg-12 col-sm-12 col-12">
                <div className="banner-content">
                  <h1 className="sub-page-title">
                    Let's Connect and Navigate
                  </h1>
                  <p className="subs-title">
                    Gain access to a treasure trove of valuable resources,
                    insightful courses, and expert insights at no cost.
                    Whether you're a beginner or a seasoned pro, our free
                    subscription is your passport to learning and growing in
                    the real estate industry. Don't miss out on this golden
                    opportunity – sign up now and unlock the door to a
                    brighter real estate future, no strings attached!
                  </p>
                </div>
                <div className="login-text-contact">
                  <div
                    className="text-center lgo-box cursor-pointer"
                    onClick={() => navigate("/")}
                  >
                    <img src="images/logo/Untitled-6.png" alt="images" />
                  </div>
                  <h4 className="text-center logtitle">
                    Already have an account?
                    <span
                      style={{ color: "#6941c6" }}
                      onClick={() => navigate("/login")}
                      className="cursor-pointer"
                    >
                    &nbsp;Sign In
                    </span>
                  </h4>
                  <p className="ms-2-message text-center">
                    Guest Pass Available to All Real Estate Agents
                  </p>

                  <div className="mb-2 login-msg">
                    {formSuccess ? (
                      <div>{formSuccess}</div>
                    ) : formError ? (
                      <div style={{ color: "red" }}>{formError}</div>
                    ) : (
                      ""
                    )}
                  </div>
                  <form onSubmit={handleSubmit}>
                    <div className="input-text ">
                      <label htmlFor="password" className="input__label">
                        {t("Name*")}
                      </label>
                      <input
                        className="input__field"
                        name="Name"
                        type="text"
                        placeholder="Enter your first name, last name"
                        value={name}
                        onChange={(evt) => setName(evt.target.value)}
                        required
                        autoComplete="off"
                      />
                    </div>
                    <div className="input-text ">
                      <label htmlFor="password" className="input__label">
                        {t("Email*")}
                      </label>
                      <input
                        className="input__field"
                        name="email"
                        type="email"
                        placeholder="Enter your brokerage email"
                        value={email}
                        required
                        onChange={handleEmailChange}
                        onBlur={handleEmailBlur}
                        onFocus={handleEmailFocus}
                        autoComplete="off"
                      />
                      {!valid && !isEmailFocused ? (
                        <div
                          className="mb-1 mt-0 form-error"
                          style={{ color: "red" }}
                        >
                          Please Enter a Valid Email
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="input-text ">
                      <label htmlFor="password" className="input__label">
                        {t("Phone Number*")}
                      </label>
                      <input
                        className="input__field"
                        name="number"
                        type="tel"
                        pattern="[0-9]{10}"
                        placeholder="Enter your phone number"
                        value={number}
                        required
                        onChange={(evt) => setNumber(evt.target.value)}
                        autoComplete="off"
                      />
                    </div>
                    <div className="input-text ">
                      <label htmlFor="password" className="input__label">
                        {t("What brokerage are you from?")}
                      </label>
                      <input
                        className="input__field"
                        name="text"
                        type="text"
                        placeholder="Enter brokarage name"
                        value={brokerageFrom}
                        onChange={(evt) =>
                          setBrokerageFrom(evt.target.value)
                        }
                        autoComplete="off"
                      />
                    </div>
                    {/* <div className="input-lear position-relative">
                      <label
                        htmlFor="category"
                        className="input__label_learning"
                      >
                        Please mention the event you are interested in
                      </label>
                      <select
                        className="form-select input_searchfield"
                        id="category"
                        onChange={(ev) => {
                          changeSelectedEvent(ev.target.value);
                        }}
                        value={selectedSessionId}
                        required
                      >
                        <option value="">Select Event</option>
                        {interestedBrokerageEvents?.length > 0 ? (
                          <optgroup label="Brokerage Sessions">
                            {interestedBrokerageEvents.map(
                              (item, index) => {
                                return (
                                  <option
                                    value={item?.sessionId}
                                    key={index}
                                  >
                                    {`${item.sessionName} (${item.eventName})`}
                                  </option>
                                );
                              }
                            )}
                          </optgroup>
                        ) : (
                          ""
                        )}
                        {interestedXselEvents?.length > 0 ? (
                          <optgroup label="Xsel Sessions">
                            {interestedXselEvents.map((item, index) => {
                              return (
                                <option value={item?.sessionId} key={index}>
                                  {`${item.sessionName} (${item.eventName})`}
                                </option>
                              );
                            })}
                          </optgroup>
                        ) : (
                          ""
                        )}
                      </select>
                    </div> */}
                    <div className="input-text ">
                      <label htmlFor="password" className="input__label">
                        Session you are interested in
                      </label>
                      <input
                        className="input__field"
                        name="Name"
                        type="text"
                        placeholder=""
                        value={selectedSessionOfEvent}
                        // onChange={(evt) => setName(evt.target.value)}
                        disabled
                        required
                        autoComplete="off"
                      />
                    </div>
                    <div className="validation-pass">
                      <div className="valid-text ">
                        <span className="cursor-pointer click fw-bold text-decoration-underline" onClick={()=>navigate(-1)}>
                          Click here
                        </span>{" "}
                        to select another session.
                      </div>
                    </div>
                    <p className="">
                      <button className={`default-btn signinBtn mt-4 `}>
                        {isLoadingLogin ? (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : (
                          t("Submit")
                        )}
                      </button>
                    </p>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      </div>
    </>:
    <Page>
        <Loader start={isLoadingLogin} />
        <div className="contact-us-page">
          <section className="login-sec ">
            <div className="login-container ">
              <div className="container">
                <div className="row bglogin">
                  {/* <div className="col-md-12 back-btn-container">
                    <button type="button" className="view-all-btn">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        style={{transform: "scale(-1,1)"}}
                      >
                        <path
                          d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                          stroke="#6941C6"
                          strokeWidth="1.66667"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                      </svg>{" "}
                      Back
                    </button>
                  </div> */}
                  <div className="col-xl-12 col-lg-12 col-sm-12 col-12">
                    <div className="banner-content">
                      <h1 className="sub-page-title">
                        Let's Connect and Navigate
                      </h1>
                      <p className="subs-title">
                        Gain access to a treasure trove of valuable resources,
                        insightful courses, and expert insights at no cost.
                        Whether you're a beginner or a seasoned pro, our free
                        subscription is your passport to learning and growing in
                        the real estate industry. Don't miss out on this golden
                        opportunity – sign up now and unlock the door to a
                        brighter real estate future, no strings attached!
                      </p>
                    </div>
                    <div className="login-text-contact">
                      <div
                        className="text-center lgo-box cursor-pointer"
                        onClick={() => navigate("/")}
                      >
                        <img src="images/logo/Untitled-6.png" alt="images" />
                      </div>
                      <h4 className="text-center logtitle">
                        Already have an account?
                        <span
                          style={{ color: "#6941c6" }}
                          onClick={() => navigate("/login")}
                          className="cursor-pointer"
                        >
                        &nbsp;Sign In
                        </span>
                      </h4>
                      <p className="ms-2-message text-center">
                        Guest Pass Available to All Real Estate Agents
                      </p>

                      <div className="mb-2 login-msg">
                        {formSuccess ? (
                          <div>{formSuccess}</div>
                        ) : formError ? (
                          <div style={{ color: "red" }}>{formError}</div>
                        ) : (
                          ""
                        )}
                      </div>
                      <form onSubmit={handleSubmit}>
                        <div className="input-text ">
                          <label htmlFor="password" className="input__label">
                            {t("Name*")}
                          </label>
                          <input
                            className="input__field"
                            name="Name"
                            type="text"
                            placeholder="Enter your first name, last name"
                            value={name}
                            onChange={(evt) => setName(evt.target.value)}
                            required
                            autoComplete="off"
                          />
                        </div>
                        <div className="input-text ">
                          <label htmlFor="password" className="input__label">
                            {t("Email*")}
                          </label>
                          <input
                            className="input__field"
                            name="email"
                            type="email"
                            placeholder="Enter your brokerage email"
                            value={email}
                            required
                            onChange={handleEmailChange}
                            onBlur={handleEmailBlur}
                            onFocus={handleEmailFocus}
                            autoComplete="off"
                          />
                          {!valid && !isEmailFocused ? (
                            <div
                              className="mb-1 mt-0 form-error"
                              style={{ color: "red" }}
                            >
                              Please Enter a Valid Email
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="input-text ">
                          <label htmlFor="password" className="input__label">
                            {t("Phone Number*")}
                          </label>
                          <input
                            className="input__field"
                            name="number"
                            type="tel"
                            pattern="[0-9]{10}"
                            placeholder="Enter your phone number"
                            value={number}
                            required
                            onChange={(evt) => setNumber(evt.target.value)}
                            autoComplete="off"
                          />
                        </div>
                        <div className="input-text ">
                          <label htmlFor="password" className="input__label">
                            {t("What brokerage are you from?")}
                          </label>
                          <input
                            className="input__field"
                            name="text"
                            type="text"
                            placeholder="Enter brokarage name"
                            value={brokerageFrom}
                            onChange={(evt) =>
                              setBrokerageFrom(evt.target.value)
                            }
                            autoComplete="off"
                          />
                        </div>
                        {/* <div className="input-lear position-relative">
                          <label
                            htmlFor="category"
                            className="input__label_learning"
                          >
                            Please mention the event you are interested in
                          </label>
                          <select
                            className="form-select input_searchfield"
                            id="category"
                            onChange={(ev) => {
                              changeSelectedEvent(ev.target.value);
                            }}
                            value={selectedSessionId}
                            required
                          >
                            <option value="">Select Event</option>
                            {interestedBrokerageEvents?.length > 0 ? (
                              <optgroup label="Brokerage Sessions">
                                {interestedBrokerageEvents.map(
                                  (item, index) => {
                                    return (
                                      <option
                                        value={item?.sessionId}
                                        key={index}
                                      >
                                        {`${item.sessionName} (${item.eventName})`}
                                      </option>
                                    );
                                  }
                                )}
                              </optgroup>
                            ) : (
                              ""
                            )}
                            {interestedXselEvents?.length > 0 ? (
                              <optgroup label="Xsel Sessions">
                                {interestedXselEvents.map((item, index) => {
                                  return (
                                    <option value={item?.sessionId} key={index}>
                                      {`${item.sessionName} (${item.eventName})`}
                                    </option>
                                  );
                                })}
                              </optgroup>
                            ) : (
                              ""
                            )}
                          </select>
                        </div> */}
                        <div className="input-text ">
                          <label htmlFor="password" className="input__label">
                            Session you are interested in
                          </label>
                          <input
                            className="input__field"
                            name="Name"
                            type="text"
                            placeholder=""
                            value={selectedSessionOfEvent}
                            // onChange={(evt) => setName(evt.target.value)}
                            disabled
                            required
                            autoComplete="off"
                          />
                        </div>
                        <div className="validation-pass">
                          <div className="valid-text ">
                            <span className="cursor-pointer click fw-bold text-decoration-underline" onClick={()=>navigate(-1)}>
                              Click here
                            </span>{" "}
                            to select another session.
                          </div>
                        </div>
                        <p className="">
                          <button className={`default-btn signinBtn mt-4 `}>
                            {isLoadingLogin ? (
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />
                            ) : (
                              t("Submit")
                            )}
                          </button>
                        </p>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </Page>
    }
    </>
  );
};

export default EventsRegistrationPage;
